import { ToolsRoutes } from "./names";

import type { AppRouteRecordRaw } from "@/app/router/types/types";

// `catalog` is an unnamed menu group: it has no page of its own, so it carries no component.
// `sales-channels` is the one page with routed tabs: it renders the tab strip and a nested
// <RouterView>, and redirects to the default tab. The tab routes stay out of the menu.
export const catalogRoutes: AppRouteRecordRaw[] = [
  {
    path: "catalog",
    meta: {
      isMenuParent: true,
      menuTitle: "Catalog",
      menuIcon: "lucide:book-open",
    },
    children: [
      {
        path: "products",
        name: ToolsRoutes.CATALOG_PRODUCTS,
        component: () => import("../../pages/catalog/ProductsPage.vue"),
        meta: {
          title: "Products",
          pageKey: "ToolsCatalogProducts",
          menuIcon: "lucide:package",
          menuOrder: 1,
        },
      },
      {
        path: "brands",
        name: ToolsRoutes.CATALOG_BRANDS,
        component: () => import("../../pages/catalog/BrandsPage.vue"),
        meta: {
          title: "Brands",
          pageKey: "ToolsCatalogBrands",
          menuIcon: "lucide:tag",
          menuOrder: 2,
          // The details page is a sibling route; Brands stays lit while it is open.
          menuActiveOn: [ToolsRoutes.CATALOG_BRAND],
        },
      },
      {
        path: "brands/:id",
        name: ToolsRoutes.CATALOG_BRAND,
        component: () => import("../../pages/catalog/BrandDetailsPage.vue"),
        // No `title`: the rail is the page's heading, and ToolsHeader draws no band without one.
        meta: {
          pageKey: "ToolsCatalogBrand",
          showInMenu: false,
        },
      },
      {
        path: "sales-channels/retailers/:id",
        name: ToolsRoutes.CATALOG_RETAILER,
        component: () => import("../../pages/catalog/RetailerDetailsPage.vue"),
        // A sibling of `sales-channels`, not a child: a child would render inside the tab strip.
        // No `title`: the rail is the page's heading, and ToolsHeader draws no band without one.
        meta: {
          pageKey: "ToolsCatalogRetailer",
          showInMenu: false,
        },
      },
      {
        path: "sales-channels",
        name: ToolsRoutes.CATALOG_SALES_CHANNELS,
        component: () => import("../../pages/catalog/SalesChannelsPage.vue"),
        redirect: { name: ToolsRoutes.CATALOG_CHANNELS },
        meta: {
          title: "Sales channels",
          menuIcon: "lucide:store",
          menuOrder: 3,
          // The tabs below have their own routes; the menu item stays lit on them.
          menuMatchNested: true,
          // The retailer's details page is a sibling route, outside the tab strip; the menu item
          // stays lit on it too.
          menuActiveOn: [ToolsRoutes.CATALOG_RETAILER],
        },
        children: [
          {
            path: "channels",
            name: ToolsRoutes.CATALOG_CHANNELS,
            component: () => import("../../pages/catalog/ChannelsPage.vue"),
            meta: {
              title: "Sales channels",
              pageKey: "ToolsCatalogChannels",
              showInMenu: false,
            },
          },
          {
            path: "retailers",
            name: ToolsRoutes.CATALOG_RETAILERS,
            component: () => import("../../pages/catalog/RetailersPage.vue"),
            meta: {
              title: "Sales channels",
              pageKey: "ToolsCatalogRetailers",
              showInMenu: false,
            },
          },
        ],
      },
    ],
  },
];
